import React from "react";

interface Props {
  label: string;
  children: React.ReactElement;
  required?: boolean;
  displayRequired?: boolean;
  tips?: string;
}

export default function FormGroup(props: Props) {
  const { label, children, tips } = props;
  return (
    <div>
      <div>
        <span className={"text-black text-sm font-inter font-medium"}>
          {label}
        </span>
        {tips && (
          <span className="text-silver text-sm font-inter font-medium float-right">
            {tips}
          </span>
        )}
      </div>
      <div className="mt-1">{children}</div>
    </div>
  );
}
